import React from 'react';
import PropTypes from 'prop-types';
import './CustomInput.css';

function CustomInput({
  icon: Icon,
  placeholder,
  type = 'text',
  baseClass = 'custom-input',
  hoverClass,
  activeClass,
  borders = '',
  bordersClassPrefix = 'border-black-',
  value,
  onChange,
  onFocus,
  onBlur,
  name,
  readOnly,
  disabled,
  autoComplete,
  maxLength,
  onKeyDown,
}) {
  // Generowanie klas dla ramek na podstawie borders
  const borderClasses = borders
    .split('')
    .map((char) => `${bordersClassPrefix}${char}`)
    .join(' ');

  return (
    <div className={`${baseClass} ${activeClass} ${borderClasses}`}>
      {Icon && <Icon className="input-icon" />}
      <input
        type={type}
        className="input-field"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        name={name}
        readOnly={readOnly}
        disabled={disabled}
        autoComplete={autoComplete}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
        onMouseEnter={(e) => hoverClass && e.currentTarget.parentElement.classList.add(hoverClass)}
        onMouseLeave={(e) => hoverClass && e.currentTarget.parentElement.classList.remove(hoverClass)}
      />
    </div>
  );
}

CustomInput.propTypes = {
  icon: PropTypes.elementType, // Komponent ikony
  placeholder: PropTypes.string.isRequired, // Tekst placeholdera
  type: PropTypes.string, // Typ inputa
  baseClass: PropTypes.string, // Klasa podstawowego wyglądu (opcjonalna, z domyślną wartością)
  hoverClass: PropTypes.string, // Klasa dla hover (opcjonalna)
  activeClass: PropTypes.string, // Klasa dla stanu aktywnego
  borders: PropTypes.string, // Ciąg znaków definiujący ramki (np. "LRBT")
  bordersClassPrefix: PropTypes.string, // Prefiks klas dla ramek
  value: PropTypes.string.isRequired, // Wartość pola tekstowego
  onChange: PropTypes.func.isRequired, // Funkcja wywoływana przy zmianie wartości
  onFocus: PropTypes.func, // Funkcja wywoływana przy focusie
  onBlur: PropTypes.func, // Funkcja wywoływana przy blurze
  name: PropTypes.string, // Nazwa pola
  readOnly: PropTypes.bool, // Czy pole tylko do odczytu
  disabled: PropTypes.bool, // Czy pole jest wyłączone
  autoComplete: PropTypes.string, // AutoComplete
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Max length
  onKeyDown: PropTypes.func, // Obsługa klawiszy
};

CustomInput.defaultProps = {
  baseClass: 'custom-input', // Domyślna wartość dla baseClass
  borders: '', // Domyślnie brak ramek
  bordersClassPrefix: 'border-black-', // Domyślny prefiks dla klas ramek
  activeClass: '', // Domyślnie brak klasy aktywnej
  hoverClass: '', // Domyślnie brak klasy hover
  onFocus: () => {}, // Domyślna funkcja focus
  onBlur: () => {}, // Domyślna funkcja blur
  name: '',
  readOnly: false,
  disabled: false,
  autoComplete: '',
  maxLength: undefined,
  onKeyDown: () => {},
};

export default CustomInput;
